var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"caption-title van-hairline--top-bottom"},[_c('img',{staticClass:"cpation_icon",attrs:{"src":_vm.capIcon}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }